import { makeUrl, routes, useRouteMatch } from "../lib/urls";
import { TabHeaderBar, Tabs } from "./TabHeader";
import { TabLink } from "./TabLink";

type Props = {
  workflowsCount: number;
  autofixCount: number;
  autotuneCount: number;
};

export function RecentsTabHeader({
  workflowsCount,
  autofixCount,
  autotuneCount,
}: Props) {
  const [isAutofix] = useRouteMatch(routes.recents.autofix);
  const [isAutotune] = useRouteMatch(routes.recents.autotune);
  const isWorkflows = !isAutofix && !isAutotune;

  return (
    <TabHeaderBar>
      <Tabs>
        <TabLink
          to={makeUrl(routes.recents)}
          active={isWorkflows}
          icon="product-workflows"
          label="Workflows"
          count={workflowsCount > 0 ? workflowsCount : null}
        />
        <TabLink
          to={makeUrl(routes.recents.autofix)}
          active={isAutofix}
          icon="radar"
          label="Autofix"
          count={autofixCount > 0 ? autofixCount : null}
        />
        <TabLink
          to={makeUrl(routes.recents.autotune)}
          active={isAutotune}
          icon="audio-waveform"
          label="Autotune"
          count={autotuneCount > 0 ? autotuneCount : null}
        />
      </Tabs>
    </TabHeaderBar>
  );
}
